import React from 'react';
import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

const SuccessContainer = styled(Box)({
    marginBottom: '20px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
});

const SuccessHeading = styled(Typography)({
    fontSize: '32px',
    fontWeight: 600,
    color: '#ffffff',
    marginBottom: '24px',
    marginTop: '24px',
});

const SuccessMessage = styled(Typography)({
    fontSize: '16px',
    color: '#b0b8c4',
    lineHeight: '1.6',
    maxWidth: '500px',
});

interface PasswordResetSuccessProps {
    show: boolean;
}

const PasswordResetSuccess: React.FC<PasswordResetSuccessProps> = ({ show }) => {
    if (!show) return null;

    return (
        <SuccessContainer>
            <SuccessHeading>Password Reset Success!</SuccessHeading>
            <SuccessMessage>
                Your Jeppesen password reset was successful.
                <br />
                You can now login using your new credentials.
            </SuccessMessage>
        </SuccessContainer>
    );
};

export default PasswordResetSuccess;
